export class BaseUser {
  constructor(public email: string, public uid: string, public role?: string, public firstName?: string, public lastName?: string, public imageUrl?: string) {}

  getUserString(): string {
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.lastName}`;
    }

    return this.email;
  }
}

export enum UserRole {
  Guest = 0, // Unauthorized user (NO RIGHTS)
  User = 1, // Can upload and see only his videos
  Supervisor = 2, // Can see everybody and everything except manage employees
  Commander = 3, // Can upload videos and see videos of subordinates (multilevel)
  HRAdmin = 4, // Manage Users
  SuperAdmin = 5, // Everything
  Kiosk = 6, // Used only for activation of Kiosk mode, without any rights
  Prosecutor = 7, // Can upload and see only his videos
  NonInteractiveUser = 8, // Not real users, eg. Drills
  ReadOnlyApiUser = 9, // Api User for external services with read only permissions
}

export enum AccountTypes {
  None = 0,
  Local = 1,
  Social = 2,
}
